const Houses = () => (
  <g>
    {[0, 1, 2].map((i) => {
      const x = 70 + i * 90;
      return (
        <g key={i}>
          <path d={`M${x} 210 V140 L${x + 40} 105 L${x + 80} 140 V210`} />
          <rect x={x + 14} y="150" width="18" height="20" />
          <rect x={x + 48} y="150" width="18" height="20" />
          <rect x={x + 31} y="182" width="18" height="28" />
        </g>
      );
    })}
  </g>
);

const Apartments = () => (
  <g>
    <rect x="110" y="70" width="180" height="140" />
    {[0, 1, 2, 3].map((r) =>
      [0, 1, 2, 3, 4].map((c) => <rect key={`${r}-${c}`} x={124 + c * 32} y={84 + r * 30} width="20" height="16" />)
    )}
  </g>
);

const Mixed = () => (
  <g>
    <rect x="60" y="80" width="120" height="130" />
    {[0, 1, 2].map((r) => [0, 1, 2].map((c) => <rect key={`${r}-${c}`} x={74 + c * 36} y={94 + r * 36} width="20" height="18" />))}
    {[0, 1].map((i) => {
      const x = 200 + i * 75;
      return (
        <g key={i}>
          <path d={`M${x} 210 V150 L${x + 32} 122 L${x + 64} 150 V210`} />
          <rect x={x + 22} y="180" width="20" height="30" />
        </g>
      );
    })}
  </g>
);

const SHAPES = { houses: Houses, apartments: Apartments, mixed: Mixed };

export const ProjectPlaceholder = ({ project }) => {
  const Shape = SHAPES[project?.type] || Houses;
  return (
    <div className="relative h-full w-full bg-canvas-800 cad-grid" data-testid={`project-placeholder-${project?.slug}`}>
      <svg viewBox="0 0 400 300" className="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid meet" aria-hidden>
        <g fill="none" stroke="#1A5FC4" strokeWidth="1.4" strokeLinejoin="round">
          <Shape />
        </g>
        <g stroke="#5B6573" strokeWidth="1">
          <line x1="40" y1="210" x2="360" y2="210" />
          <line x1="60" y1="236" x2="340" y2="236" />
          <line x1="60" y1="230" x2="60" y2="242" />
          <line x1="340" y1="230" x2="340" y2="242" />
        </g>
        <text x="200" y="256" textAnchor="middle" fill="#5B6573" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="2">
          ELEVATION · NTS
        </text>
      </svg>
      <span className="label-mono absolute bottom-3 right-3 text-steel">Photo to follow</span>
    </div>
  );
};

export const ProjectMedia = ({ project, className = "", imgClassName = "" }) => (
  <div className={`relative overflow-hidden border border-canvas-line bg-canvas-800 ${className}`}>
    {project?.image ? (
      <img src={project.image} alt={`${project.name}, ${project.location}`} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} />
    ) : (
      <ProjectPlaceholder project={project} />
    )}
    <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_60px_rgba(0,0,0,0.12)]" aria-hidden />
    {project?.imageNote && <span className="label-mono absolute bottom-3 right-3 bg-canvas/85 px-2 py-1 text-ink">{project.imageNote}</span>}
  </div>
);
